module.exports = __webpack_public_path__ + "img/sm.1553b4ae.svg";